import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
    selector: 'app-range-time-picker',
    templateUrl: './range-time-picker.component.html',
    styleUrls: ['./range-time-picker.component.scss'],
    standalone: false
})
export class RangeTimePickerComponent implements OnInit, OnChanges {
    @Input() disabled: boolean;
    @Input() time: string;
    @Input() oppositeTime: string;
    @Input() type: string;
    @Output() timeChange = new EventEmitter<string>();
    @ViewChild("hours") hoursEl: ElementRef;
    @ViewChild("minutes") minutesEl: ElementRef;

    hoursArr: string[] = Array(25).fill(1).map((_, i) => i.toString().padStart(2, '0'));
    minutesArr: string[] = Array(4).fill(1).map((_, i) => (i * 15).toString().padStart(2, '0'));
    hours: string = "00";
    minutes: string = "00";
    isOpen: boolean;

    ngOnInit(): void {
        this.fillArrays();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.oppositeTime) {
          this.oppositeTime = this.type === "from" ? "24:00" : "00:00";
        }
        if (!this.time) {
            this.time = '00:00';
            this.timeChange.emit(this.time);
        }

        this.fillArrays();
    }

    setHours($event, h) {
        $event.stopPropagation();
        this.hours = h;
        if (this.type === "from") {
            if (+(h) === +(this.oppositeTime.split(":")[0]) && +(this.minutes) > +(this.oppositeTime.split(":")[1])) {
                this.minutes = this.oppositeTime.split(":")[1];
            }
        } else {
            if (+(h) === +(this.oppositeTime.split(":")[0]) && +(this.minutes) < +(this.oppositeTime.split(":")[1])) {
                this.minutes = this.oppositeTime.split(":")[1];
            }
        }
        this.time = `${this.hours}:${this.minutes}`;
        this.timeChange.emit(this.time);
    }

    setMinutes($event, m) {
        $event.stopPropagation();
        this.minutes = m;
        this.time = `${this.hours}:${this.minutes}`;
        this.timeChange.emit(this.time);
    }

    HoursScroll($event, interval) {
        $event.stopPropagation();
        let element = this.hoursEl.nativeElement as HTMLElement;
        element.scrollTop += interval;
    }

    MinutesScroll($event, interval) {
        $event.stopPropagation();
        let element = this.minutesEl.nativeElement as HTMLElement;
        element.scrollTop += interval;
    }

    modelChanged() {
        this.timeChange.emit(this.time);
    }

    fillArrays() {
        switch (this.type) {
            case "from": this.handleFromHours(); break;
            case "to": this.handleToHours(); break;
        }
    }

    handleFromHours() {
        if (!this.oppositeTime) this.oppositeTime = "24:00";
        let fromHour = +(this.time.split(":")[0]);
        let toHour = +(this.oppositeTime.split(":")[0]);
        let toMinutes = +(this.oppositeTime.split(":")[1]);
        let multiplier = toMinutes / 15;

        let hoursArr = [];
        let minutesArr = [];

        for (let i = 0; i <= toHour; i++) {
            if (i !== 24) {
                hoursArr.push((i).toString().padStart(2, '0'));
            }
        }

        if (toHour === fromHour && toHour !== 24) {
            switch (multiplier) {
                case 0: minutesArr = []; break;
                case 1: minutesArr = ["00", "15"]; break;
                case 2: minutesArr = ["00", "15", "30"]; break;
                case 3: minutesArr = ["00", "15", "30", "45"]; break;
            }
        } else {
            if (fromHour !== 24) {
                minutesArr = ["00", "15", "30", "45"];
            }
        }

        this.hoursArr = [...hoursArr];
        this.minutesArr = [...minutesArr];
    }

    handleToHours() {
        let toHour = +(this.time.split(":")[0]);
        let fromHour = +(this.oppositeTime.split(":")[0]);
        let fromMinutes = +(this.oppositeTime.split(":")[1]);
        let multiplier = fromMinutes / 15;

        let hoursArr = [];
        let minutesArr = [];

        for (let i = 0; i <= 24 - fromHour; i++) {
            hoursArr.push((i + fromHour).toString().padStart(2, '0'));
        }

        if (fromHour === toHour && fromHour !== 24) {
            switch (multiplier) {
                case 0: minutesArr = ["00", "15", "30", "45"]; break;
                case 1: minutesArr = ["15", "30", "45"]; break;
                case 2: minutesArr = ["30", "45"]; break;
                case 3: minutesArr = ["45"]; break;
            }
        } else {
            if (toHour !== 24) {
                minutesArr = ["00", "15", "30", "45"];
            }
        }

        this.hoursArr = [...hoursArr];
        this.minutesArr = [...minutesArr];
    }
}
